import React from "react";
import PelvicSense from "../img/PelvicSense-Logo_FullHorizontal.png";
import { Link } from 'react-router-dom'
import "../styles/pelvicCareProgram.css"

const PelvicSenseSectionForIndividualPage = () => {
  return (
    <div className="pelvic-program-banner-individual" id="PelvicSenseSectionForIndividualPage">
      <h1 className="text-al fs-pelvic-sense-banner-title-48-32 text-black text-center">
        Start Healing with a Digital Program at Home{" "}
      </h1>
      <div className="d-flex justify-content-center mb-3">
        <img
          className="pelvic-sense-image"
          src={PelvicSense}
          alt="pelvic-sense"
        />
      </div>
      <p className="text-center text-dm m-0 fs-20-16 mb-5">
        Elana has teamed up with PelvicSense, an affordable online pelvic
        healing program.
        <br className="tablet-view-hidden" />{" "}
        It includes gentle progressive body exercise videos, education, and
        calming mind exercises.
      </p>
      <div className="d-flex justify-content-center">
        <Link to="/pelvicCareProgram">
          <button className="border-0 pelvic-sense-button py-3 px-5 text-nowrap card-button">
            HOW DOES IT WORK?
          </button>
        </Link>
      </div>
    </div>
  );
};

export default PelvicSenseSectionForIndividualPage;
